import React, { useState, useEffect } from 'react';
import { Save } from 'lucide-react';
import api from '../../api';
import { toast } from 'sonner';
import ImageUpload from './ImageUpload';
import { DEFAULT_IMAGES } from '../../context/SiteImagesContext';

// Labels for each image slot, grouped by page
const groups = [
  {
    page: "Page d'accueil",
    slots: [
      { key: 'home_hero', label: 'Grand visuel principal (Hero)' },
    ],
  },
  {
    page: "Qu'est-ce que la GR ?",
    slots: [
      { key: 'whatisgr_hero', label: 'Bannière de la page' },
      { key: 'whatisgr_gallery_1', label: 'Image galerie 1 (Élégance)' },
      { key: 'whatisgr_gallery_2', label: 'Image galerie 2 (Performance)' },
    ],
  },
  {
    page: 'Notre Club',
    slots: [
      { key: 'ourclub_hero', label: 'Bannière de la page' },
      { key: 'ourclub_intro', label: "Photo d'introduction (entre le titre et le texte)" },
    ],
  },
  {
    page: 'Inscriptions',
    slots: [{ key: 'inscriptions_hero', label: 'Bannière de la page' }],
  },
  {
    page: 'Actualités',
    slots: [{ key: 'actualites_hero', label: 'Bannière de la page' }],
  },
  {
    page: 'Résultats & Galas',
    slots: [{ key: 'results_hero', label: 'Bannière de la page' }],
  },
  {
    page: 'Boutique',
    slots: [{ key: 'boutique_hero', label: 'Grand visuel de la page' }],
  },
];

const MediaManager = () => {
  const [images, setImages] = useState(DEFAULT_IMAGES);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/site-images')
      .then((r) => setImages({ ...DEFAULT_IMAGES, ...(r.data.images || {}) }))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const setImg = (key, url) => setImages((prev) => ({ ...prev, [key]: url }));

  const save = async () => {
    try {
      await api.put('/site-images', { images });
      toast.success('Images enregistrées');
    } catch (e) {
      toast.error('Erreur lors de la sauvegarde');
    }
  };

  if (loading) return <p className="text-white/50">Chargement...</p>;

  return (
    <div data-testid="media-manager">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-white">Images des pages</h2>
        <button onClick={save} data-testid="save-media-btn" className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-fuchsia-500 to-pink-500 rounded-lg text-white font-medium hover:shadow-lg hover:shadow-fuchsia-500/30 transition-all">
          <Save size={18} /> Enregistrer
        </button>
      </div>
      <p className="text-white/50 text-sm mb-8">Remplacez ici les visuels de chaque page du site. Téléversez vos propres photos, puis cliquez sur « Enregistrer ».</p>

      <div className="space-y-10 max-w-3xl">
        {groups.map((g) => (
          <div key={g.page}>
            <h3 className="text-lg font-semibold text-fuchsia-400 mb-4 pb-2 border-b border-white/10">{g.page}</h3>
            <div className="space-y-6">
              {g.slots.map((slot) => (
                <div key={slot.key} data-testid={`media-slot-${slot.key}`}>
                  <ImageUpload
                    value={images[slot.key]}
                    onChange={(url) => setImg(slot.key, url)}
                    label={slot.label}
                    testId={`upload-${slot.key}`}
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-10 max-w-3xl">
        <button onClick={save} className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-fuchsia-500 to-pink-500 rounded-lg text-white font-medium">
          <Save size={18} /> Enregistrer toutes les images
        </button>
      </div>
    </div>
  );
};

export default MediaManager;
